import { createFileRoute, redirect } from '@tanstack/react-router'
import { useAuthStore } from '@/features/auth'
import { CreatorEarningsPage } from '@/features/creator-earnings'

export const Route = createFileRoute('/_authenticated/admin/creator-earnings/')({
  beforeLoad: () => {
    const { auth } = useAuthStore.getState()
    if (auth.user?.role !== 'admin' && auth.user?.role !== 'super_admin') {
      throw redirect({ to: '/403' })
    }
  },
  component: CreatorEarningsPage,
})
